<template>
  <div>
    <div class="row mb-1">
      <div class="col-sm-6">
        <h4 class="text-uppercase mt-1">{{ lexicon.drop_orders }}</h4>
      </div>
      <div class="col-sm-6 text-right full-btn">
        <div v-if="user.admin">

          <autocomplete @input="changeUser" v-if="users.length"
              :placeholder="lexicon.drop_select_customer"
              :items="users"
          />
        </div>
        <router-link :to="{'name':'order'}" v-else>
          <button class="btn btn-primary ">
            <i class="feather icon-plus"></i>
            {{ lexicon.drop_new_order }}
          </button>
        </router-link>
      </div>
    </div>
    <section id="orderssWrapper" class="card">

      <div class="card-content">
        <div class="card-body">
          <div class="card-text">
            <v-client-table :data="tableData" :columns="columns" :options="options" v-if="!loading">

              <div slot="id" slot-scope="props">
                <small class="mr-1">#{{ props.row.id }}</small>
                <small class="badge no-pointer-events "
                    :class="'badge-status-'+ props.row.status_code">{{lexicon['drop_new_status_'+props.row.status_code] }}
                </small>
                <br>
                {{ $moment(props.row.createdon).format('DD.MM.YYYY HH:mm') }}

              </div>
              <div slot="description" slot-scope="props">
                {{ props.row.np_status }}
                <em v-if="props.row.np_status == ''" class="text-muted small">
                  {{ lexicon.drop_info_na }}
                </em>
                <br>
                <a target="_blank" v-if="props.row.dp === 'drop_delivery_up'"
                    :href="'https://track.ukrposhta.ua/tracking_UA.html?barcode=' + props.row.ttn ">
                  {{ props.row.ttn }}

                </a>
                <a target="_blank" v-else
                    :href="'https://novaposhta.ua/tracking/?cargo_number=' + props.row.ttn ">
                  {{ props.row.ttn }}

                </a>


              </div>
              <div slot="cost" slot-scope="props">

                {{ props.row.cost.toFixed(2) }}
                <small class="text-muted">{{lexicon[props.row.cc]}}</small>

              </div>
              <div slot="name" slot-scope="props">
                <small v-if="user.admin">
                  <em>[{{ props.row.drop_name }}]</em>
                  <br>
                </small>
                {{ props.row.name }}
                <br>
                +{{ props.row.phone }}
              </div>
              <div slot="city" slot-scope="props">
                <span class="text-info">{{lexicon[props.row.dp]}}</span><br>
                {{ props.row.city }}
                <br>
                <small class="d-block" style="max-width: 400px">{{ props.row.sklad }}</small>
              </div>

              <div slot="nal" slot-scope="props">

                <span v-if="props.row.nal" class="text-success">{{ props.row.nal }} {{lexicon[props.row.cc]}}</span>
                <span v-else class="text-danger">{{ lexicon.drop_no }}</span>
              </div>

            </v-client-table>
            <template v-else>
              <div class="text-center">
                <div class="spinner-border text-primary my-5" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import {mapGetters, mapState} from 'vuex'
import axios from "axios";
import OrderInfo from "../components/table/OrderInfo";
import {Event} from 'vue-tables-2';
import autocomplete from '../components/UserAutocomplete'

export default {
  name: 'orders',
  components: {
    autocomplete
  },
  data() {
    return {
      loading: true,
      user_id: '',
      users: [],
      columns: ["id", "createdon", "cost", "description", 'ttn', 'nal', 'name', 'phone', 'city', 'sklad', 'products'],
      tableData: [],
      options: {

        sortable: ["id", "cost", 'nal'],
        headings: {},
        rowClassCallback(row) {
          return "order-status-" + row.status_code;
        },
        skin: "table    ",
        dateFormat: 'DD.MM.YYYY HH:mm',
        dateColumns: ['createdon'],
        texts: {
        },
        sortIcon: {base: 'feather', up: 'icon-arrow-up', down: 'icon-arrow-down', is: 'icon-sliders'},
        columnsClasses: {
          'createdon': 'd-none',
          'ttn': 'd-none',
          'phone': 'd-none',
          'sklad': 'd-none',
          'products': 'd-none',
        },
        childRowTogglerFirst: false,
        childRow: OrderInfo,
        perPage: 25,
        filterable: true,
        customFilters: [
          {
            name: 'status_code',
            callback: function (row, query) {
              return row.status_code == query;
            }
          },
          {
            name: 'np_status',
            callback: function (row, query) {
              return row.np_status_id == query;
            }
          }, {
            name: 'period',
            callback: function (row, query) {
              return row.createdon >= query.start && row.createdon <= query.end;
            }
          },
        ],
        initFilters: {
          // period: {'start': window.moment().add(-1, 'month'), 'end': window.moment()}
        },
        period: {},
        toggleElements: []
      }
    };
  },
  created() {
    Event.$on('wait-period', this.changePeriod)
    Event.$on('vue-tables.filter', this.tableEvents)
    this.options.texts = {
      count: this.lexicon.drop_pager_orders,
      first: "First",
      last: "Last",
      filter: this.lexicon.drop_search_input +":",
      filterPlaceholder: this.lexicon.drop_search_input +" ...",
      limit: this.lexicon.drop_show_till,
      page: this.lexicon.drop_page,
      noResults: this.lexicon.drop_no_results,
      filterBy: this.lexicon.drop_col_filter,
      loading: this.lexicon.drop_loading,
      defaultOption: this.lexicon.drop_selected_col,
      columns: this.lexicon.drop_columns,
    }
    this.options.headings = {
      id: '#',
      createdon: '',
      cost: this.lexicon.drop_cost,
      description: this.lexicon.drop_delivery,
      nal: this.lexicon.drop_np,
      comment: '',
      name: this.lexicon.drop_receiver,
      city: this.lexicon.drop_address,
      buttons: this.lexicon.drop_actions,
    }

    this.fetchData()
    if (this.user.admin) {
      this.usersData()
    }

  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
    }),
    ...mapState({
      lexicon: state => state.lexicon
    }),
  },
  watch: {
    $route: 'fetchData',
  },
  methods: {
    fetchData() {
      this.loading = true
      let reqData = {};
      if (this.user.admin) {
        reqData = {'period': this.period, 'user_id': this.user_id};
      }
      axios.post('orders/', reqData).then((response) => {
        this.loading = false
        const list = response.data.data
        this.tableData = list.map(function (obj) {
          obj.cost = parseFloat(obj.cost);
          obj.nal = (obj.nal > 0) ? obj.nal : false;
          obj.createdon = window.moment(obj.createdon);
          return obj;
        });
        if (this.tableData.length > 0) {
          this.period = [window.moment(this.tableData.slice(-1).pop().createdon).format('YYYY-MM-DD'), window.moment(this.tableData.slice(0, 1).pop().createdon).format('YYYY-MM-DD')]
        }

      })
    },
    changePeriod() {
      Event.$emit('change-period', this.period);
    },
    tableEvents() {
      var elements = document.getElementsByClassName('VueTables__child-row-toggler--open')
      elements.forEach((element) => {
        element.click()
      });
    },
    usersData() {
      axios.get('users/').then((response) => {
        this.users = response.data.data
      })
    },
    changeUser(value) {
      this.user_id = value.ref
      this.fetchData()
    }
  }
}


</script>


<style>
.cell-createdon {
  display: none;
}
</style>